<template>
  <div class="width-el ml-auto">
    <div class="d-flex justify-content-start">
      <TextBlock
        :text="$t('_web_tournament_operators', 'Tournament operators')"
        :size="1.125"
        :variant="'bold'"
        :line-height="1.5"
      />
      <router-link
        v-if="canCreateTournament"
        :to="{
          name: 'TournamentSettings',
          params: $route.params,
          hash: '#settings-admin',
        }"
        class="d-flex cursor-pointer"
      >
        <Icon name="edit" width="12" class="ml-3 mr-3" />
      </router-link>
    </div>
    <template v-if="data.length">
      <div class="d-flex flex-wrap justify-content-around">
        <div v-for="(acc, index) in data" :key="index">
          <LinkAccount :id="acc.id" class="login" :type="'profile'">
            <div
              class="d-flex flex-column m-3 justify-center align-items-center"
            >
              <Avatar :img-url="acc.avatar" :type="'profile'" :size="32" />
              <span>{{ acc.id }}</span>
            </div>
          </LinkAccount>
        </div>
      </div>
    </template>
    <TextBlock
      v-else
      :text="
        $t('_web_no-operators', 'No operators selected for this tournament')
      "
      variant="secondary"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import { translate } from '@/mixins/translate';
import TextBlock from '@/components/atoms/TextBlock';
import LinkAccount from '@/components/links/Account';
import Avatar from '@/components/images/Avatar';
import Icon from '@/components/atoms/Icon';

export default {
  name: 'TournamentAdminWidget',
  components: {
    TextBlock,
    LinkAccount,
    Avatar,
    Icon,
  },
  mixins: [translate('_web_tournament_dashboard')],

  data() {
    return {
      data: [],
    };
  },
  computed: {
    ...mapState('my', ['account']),
    ...mapGetters([
      'currentTournament',
      'hasAccessByPermission',
      'permissions',
    ]),
    canCreateTournament() {
      // TODO TH-8800
      // Hiding a button for a Regional Operator.
      // That has "administrative: all" permission but should not create tournaments (backend problem).
      return this.account.isOrganization
        ? !!this.permissions.createTournament
        : this.hasAccessByPermission('createTournament');
    },
  },
  mounted() {
    this.setInitAdmins();
  },
  methods: {
    ...mapActions(['fetchTournamentAdmins']),

    async setInitAdmins() {
      this.data = await this.fetchTournamentAdmins({
        tournamentId: this.$route.params.tournamentID,
      });
    },
  },
};
</script>

<style lang="scss">
.tournament-dashboard-sponsors-wrapper {
  .subheader {
    text-align: center;
  }
}
.width-el {
  width: 83%;
}
</style>
